export function recursivelyTestChildren(el: Element, test: (el: Element) => boolean): boolean {
    const queue: Set<Element> = new Set();
    for (const child of el.children) {
        queue.add(child);
    }
    while (queue.size > 0) {
        const els = Array.from(queue.keys());
        for (const el of els) {
            queue.delete(el);
            if (test(el)) {
                return true;
            }
            for (const child of el.children) {
                queue.add(child);
            }
        }
    }
    return false;
}
